import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule,ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { IonicModule } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { FormsModule } from '@angular/forms';

import {Ng2UiAuthModule} from 'ng2-ui-auth';
import { ActionCableService } from 'angular2-actioncable';
import { AuthenticationService } from "./providers/authentication/auth";
import { MyErrorHandler } from "./providers/handleError"
import { HandleRequest } from "./providers/handleRequest"
import { WebsocketProvider } from "./providers/websocket"
import { AuthTokenStatus } from './providers/authentication/authTokenStatus';
import { AudioCallService } from './providers/audio-call.service';
import { PartialsModule } from './partials/partials.module';

declare var CONFIG:any;
export function AuthTokenStatusFactory(provider: AuthTokenStatus) {
  return () => provider.load();
}
@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production
    }),
    Ng2UiAuthModule.forRoot({ tokenName: 'voipboxIonAppToken',
                              tokenPrefix: '',
                              baseUrl: CONFIG.API_ENDPOINT,
                              loginUrl: CONFIG.API_ENDPOINT+"/api/login",
                              providers: {google: { clientId: "GOOGLE_CLIENT_ID"}}
                            }),
    PartialsModule
  ],
  declarations: [AppComponent],
  providers: [
    InAppBrowser, 
    AuthenticationService,
    { provide: ErrorHandler, useClass: MyErrorHandler },
    HandleRequest,AuthTokenStatus,
    ActionCableService, WebsocketProvider,AudioCallService,
    {
      provide: APP_INITIALIZER,
      useFactory: AuthTokenStatusFactory,
      deps: [AuthTokenStatus],
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
